import { Layout, PageHeader } from "@/components/Layout";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ShoppingCart, Navigation, Plug } from "lucide-react";

const INTEGRATIONS = [
  {
    id: "coupa",
    name: "Coupa",
    icon: ShoppingCart,
    tag: "Procurement",
    color: "#0055FF",
    desc: "Sync purchase orders & requisitions with Coupa spend management. Push work-order costs and pull approved POs to auto-create logistics requisitions.",
    planned: ["PO → Requisition sync", "Cost actuals push-back", "Supplier catalog import"],
  },
  {
    id: "geotab",
    name: "Geotab",
    icon: Navigation,
    tag: "Telematics / GPS",
    color: "#16a34a",
    desc: "Connect Geotab telematics for live vehicle GPS, engine hours, and mileage. Auto-populate trip distances and actual times from real fleet data.",
    planned: ["Live truck GPS on Schedule board", "Auto trip mileage & hours", "Fuel & idle analytics"],
  },
];

export default function Integrations() {
  return (
    <Layout>
      <PageHeader title="Integrations" subtitle="Connect Ghost TMS to your procurement & telematics stack" />
      <div className="p-8 animate-fade-up">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 max-w-4xl">
          {INTEGRATIONS.map((it) => {
            const Icon = it.icon;
            return (
              <Card key={it.id} data-testid={`integration-${it.id}`} className="p-6 border-border/60 shadow-none bg-white">
                <div className="flex items-start justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <div className="h-11 w-11 rounded-md grid place-items-center" style={{ background: `${it.color}15` }}>
                      <Icon className="h-6 w-6" style={{ color: it.color }} />
                    </div>
                    <div>
                      <div className="font-display font-bold text-lg leading-none">{it.name}</div>
                      <div className="text-xs text-muted-foreground mt-1">{it.tag}</div>
                    </div>
                  </div>
                  <Badge variant="secondary" className="bg-amber-100 text-amber-800 hover:bg-amber-100">Planned</Badge>
                </div>
                <p className="text-sm text-neutral-600 leading-relaxed">{it.desc}</p>
                <ul className="mt-4 space-y-1.5">
                  {it.planned.map((p) => (
                    <li key={p} className="flex items-center gap-2 text-sm text-neutral-700">
                      <span className="h-1.5 w-1.5 rounded-full" style={{ background: it.color }} />{p}
                    </li>
                  ))}
                </ul>
                <button disabled data-testid={`connect-${it.id}-btn`}
                  className="mt-5 w-full rounded-md border border-border/60 py-2 text-sm font-semibold text-muted-foreground bg-neutral-50 cursor-not-allowed">
                  Connect (coming soon)
                </button>
              </Card>
            );
          })}
        </div>
        <div className="mt-6 max-w-4xl flex items-center gap-2 text-xs text-muted-foreground">
          <Plug className="h-4 w-4" />
          These connectors are architected for a future release. Let us know which to prioritize.
        </div>
      </div>
    </Layout>
  );
}
